import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { useEffect, useState } from "react";

const columns = [
  { id: "name", label: "HospitalName", minWidth: 170 },
  { id: "code", label: "States", minWidth: 100 },
  {
    id: "population",
    label: "Address",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "size",
    label: "Number of Beds Available",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "density",
    label: "Number of Covid Vaccines",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
];

function createData(name, code, population, size, density) {
  return { name, code, population, size, density };
}

var state = "1";
var url = "http://127.0.0.1:8000/apis/hospital-list/state=1/"
// + state + "/";
 let rows=[]
fetch(url, {
  mode: "cors",
  method: "get",
})
  .then((response) => response.json())
  .then(
    (data) =>
            data.map((data,i)=>{
                console.log(data,i)
                    rows.push(createData(data.hospitalName, data.hospitalState, data.hospitalAddress, data.bedsOccupied,i*100 +  data.bedsOccupied ))
            })
  );


// fetch(url, {
//   mode: "cors",
//   method: "get",
// })
//   .then((response) => response.json())
//   .then(
//     (data) =>
//       // this.setState({ posts: data },()=>{this.recommendUsers();
//       // console.log(data)
//     //
//     // }
//   );

// fetch(url, {
//       mode:'cors',
//       method: "get",
//     })
//     .then((response) => response.json(), )
//     .then((data) =>
//     this.setState({ posts: data },()=>{this.recommendUsers();
//     }
//       )
//     );





const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 440,
  },
});

export default function HospitalPage() {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

// function HospitalPage() {
// return(
//   <div>
//
//   </div>
// );
// }
//
// export default HospitalPage;
